<app-page [hideSidebar]="true">
  <wallet></wallet>
</app-page>
